/* eslint-disable react/prop-types, react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';
import ArticleList from '@spp/ui-article-list';
import { ImageAsset } from '@spp/ui-image';

const assembleQueryParams = (params) =>
    Object.keys(params)
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join('&');

const articleRenderer = ({ article, imageAssetSizes, theme, onClick, utmParams }) => {
    const imageAsset = article.promotionContent.imageAsset ? (
        <ImageAsset
            theme={theme.image}
            urls={article.promotionContent.imageAsset.urls}
            sizes={imageAssetSizes}
            testTag={'@spp/ui-article-list:image-asset'}
        />
    ) : (
        <img src={config.shareDefaults.image} alt={article.promotionContent.title.value} />
    );

    const isPaywall = article.customProperties.vg_paywall;
    // show indicator only if paywall
    // and image asset is present
    const indicator =
        isPaywall && imageAsset !== null ? <div className={theme.plusIndicator} /> : null;

    let href = article.links.canonicalUrl;
    if (utmParams) {
        href += (href.indexOf('?') === -1 ? '?' : '&') + assembleQueryParams(utmParams);
    }

    return (
        <a
            className={theme.articleLink}
            data-test-tag="@spp/ui-article-list:link"
            href={href}
            aria-label={article.promotionContent.title.value}
            data-article-id={article.id}
            onClick={onClick}
        >
            <div className={theme.imageWrapper}>
                {imageAsset}
                {indicator}
            </div>
            <span className={theme.articleHeader}>{article.promotionContent.title.value}</span>
        </a>
    );
};

class List extends React.PureComponent {
    static propTypes = {
        theme: PropTypes.object,
        articles: PropTypes.array.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        utmParams: PropTypes.object,
    };

    static defaultProps = {
        theme: {},
    };

    render() {
        const { articles, theme, title, description, onClick, utmParams } = this.props;
        const imageAssetSizes = '(min-width: 980px) 300px, 50vw';

        return (
            <ArticleList
                theme={theme}
                header={title}
                articleList={articles}
                ariaLabel={description}
                imageAssetSizes={imageAssetSizes}
                articleRenderer={(article) =>
                    articleRenderer({
                        article,
                        imageAssetSizes,
                        theme,
                        utmParams,
                        onClick,
                    })
                }
            />
        );
    }
}

export default List;



/** WEBPACK FOOTER **
 ** ./src/local-components/List.js
 **/